export const environment = {
    production: true,
    staticResourcePath: `${window.VELO_PUBLIC_PATH}/`,
    isSafe: false
};
